import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const t = translations[language];

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-navy-dark/95 backdrop-blur-md border-b border-gold/20">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_history-escape/artifacts/786vo89j_image.png" 
              alt="T-MINUS Logo" 
              className="h-14 w-auto transition-transform group-hover:scale-105 duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="nav-link">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('rooms')} className="nav-link">
              {t.nav.rooms}
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="nav-link">
              {t.nav.howItWorks}
            </button>
            <button onClick={() => scrollToSection('prizes')} className="nav-link">
              {t.nav.prizes}
            </button>
            <button onClick={() => scrollToSection('about')} className="nav-link">
              {t.nav.about}
            </button>
            <button
              onClick={toggleLanguage}
              className="px-4 py-2 bg-accent text-cream rounded-full font-semibold text-sm uppercase tracking-wide hover:bg-accent-light transition-all duration-300 hover:scale-105"
            >
              {language === 'en' ? 'Français' : 'English'}
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gold p-2"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-6 pb-4 flex flex-col gap-4 border-t border-gold/20 pt-4">
            <button onClick={() => scrollToSection('home')} className="text-cream hover:text-gold transition-colors text-left py-2">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('rooms')} className="text-cream hover:text-gold transition-colors text-left py-2">
              {t.nav.rooms}
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-cream hover:text-gold transition-colors text-left py-2">
              {t.nav.howItWorks}
            </button>
            <button onClick={() => scrollToSection('prizes')} className="text-cream hover:text-gold transition-colors text-left py-2">
              {t.nav.prizes}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-cream hover:text-gold transition-colors text-left py-2">
              {t.nav.about}
            </button>
            <button
              onClick={toggleLanguage}
              className="px-4 py-2 bg-accent text-cream rounded-full font-semibold text-sm uppercase tracking-wide hover:bg-accent-light transition-all"
            >
              {language === 'en' ? 'Français' : 'English'}
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};